/**
 * GX Press Accordion — max-height single-open accordion (final HTML mock)
 */
(function () {
  function initPressAccordion(root) {
    if (!root || root.dataset.gxPaInit === '1') return;
    root.dataset.gxPaInit = '1';

    var triggers = root.querySelectorAll('[data-gx-pa-trigger]');
    if (!triggers.length) return;

    function setPanelHeight(panel, open) {
      if (!panel) return;
      if (open) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      } else {
        panel.style.maxHeight = '0px';
      }
    }

    triggers.forEach(function (trigger) {
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      setPanelHeight(panel, isExpanded);
    });

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var panelId = trigger.getAttribute('aria-controls');
        var panel = document.getElementById(panelId);
        if (!panel) return;
        var isExpanded = trigger.getAttribute('aria-expanded') === 'true';

        triggers.forEach(function (otherTrigger) {
          if (otherTrigger === trigger) return;
          otherTrigger.setAttribute('aria-expanded', 'false');
          setPanelHeight(document.getElementById(otherTrigger.getAttribute('aria-controls')), false);
        });

        if (isExpanded) {
          trigger.setAttribute('aria-expanded', 'false');
          setPanelHeight(panel, false);
        } else {
          trigger.setAttribute('aria-expanded', 'true');
          setPanelHeight(panel, true);
        }
      });
    });

    window.addEventListener('resize', function () {
      triggers.forEach(function (trigger) {
        if (trigger.getAttribute('aria-expanded') === 'true') {
          setPanelHeight(document.getElementById(trigger.getAttribute('aria-controls')), true);
        }
      });
    }, { passive: true });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-gx-pa-root]').forEach(initPressAccordion);
  }

  document.addEventListener('DOMContentLoaded', function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:reorder', function (e) { boot(e.target); });
})();
